// ajax模块
export default {
  'ajax.timeout': 'Sorry，something went wrong. Please try again later',
  'ajax.system': 'Sorry，something went wrong. Please try again later',
  'ajax.network': 'No network connection. Please try again later.',
};
